import React from 'react';

const flightInfoCity = (props) => (
    <span className="u-fontSize13 u-textColorDark u-fontWeightMedium">
        {props.children}
    </span>
);

export default flightInfoCity;


// WEBPACK FOOTER //
// ./src/components/Flight/Tuple/TupleInner/FlightInfo/FlightInfoCity/FlightInfoCity.js